export default __webpack_public_path__ + "static/9ce4d8553acd0b0498d0038929c676b4.jpeg";